module.exports = __webpack_public_path__ + "static/sport/regist.85c2561.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/regist.gif
// module id = BCH8
// module chunks = 0